import { Instagram, LinkedIn, Email } from '@mui/icons-material'

import './../../stylesheets/socials.css'

function Socials() {
    return (
        <div className='socials flex flex-d-col gap-1'>
            <div title='Instagram' className='icon'>
                <a className='flex flex-center' href='https://www.instagram.com/djs.nsdc' target='_blank' rel='noreferrer'>
                    <Instagram />
                </a>
            </div>
            <div title='LinkedIn' className='icon'>
                <a className='flex flex-center' href='https://www.linkedin.com/company/djs-nsdc/' target='_blank' rel='noreferrer'>
                    <LinkedIn />
                </a>
            </div>
            <div title='Email' className='icon'>
                <a className='flex flex-center' href="mailto:djsce.nsdc12@gmail.com" target='_blank' rel='noreferrer'>
                    <Email />
                </a>
            </div>
        </div>

    )
}

export default Socials